export const BRAND_NAME = "Идеалитика";
export const BRAND_TAGLINE = "by SmartBiznes";
export const BRAND_ACCENT = "#14B8A6";
export const BRAND_ACCENT_DEEP = "#0F766E";
export const BRAND_ACCENT_BRIGHT = "#5EEAD4";
